export default "__VITE_ASSET__DFugJbve__"